import type { HeroSlide } from "@/types";

export const heroSlides: HeroSlide[] = [
  {
    id: "s-1",
    newsId: "n-2001",
    title: "《长夜星河》大结局口碑逆袭",
    kicker: "本周焦点",
    image:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20palace%20at%20night%20with%20golden%20lanterns%20and%20starry%20sky%2C%20deep%20blue%20atmosphere%20with%20warm%20amber%20light%2C%20cinematic%20wide%20shot%2C%20dramatic%20scale%2C%20richly%20detailed%20ornamental%20architecture%2C%20moody%20film%20still&width=1920&height=1080&seq=aa-hero-slide-1&orientation=landscape",
  },
  {
    id: "s-2",
    newsId: "n-2002",
    title: "国庆档票房破纪录 《深海回响》领跑",
    kicker: "票房速递",
    image:
      "https://readdy.ai/api/search-image?query=deep%20sea%20submarine%20descending%20into%20glowing%20ocean%20trench%2C%20bioluminescent%20blue%20creatures%2C%20cinematic%20sci-fi%20underwater%20scene%2C%20deep%20navy%20and%20warm%20amber%20light%2C%20epic%20dramatic%20scale%2C%20highly%20detailed%20film%20still&width=1920&height=1080&seq=aa-hero-slide-2&orientation=landscape",
  },
  {
    id: "s-3",
    newsId: "n-2003",
    title: "悬疑剧《迷雾追凶》口碑封神",
    kicker: "口碑推荐",
    image:
      "https://readdy.ai/api/search-image?query=foggy%20city%20street%20at%20night%20with%20rain%20reflections%20and%20single%20street%20lamp%2C%20lone%20detective%20silhouette%2C%20cold%20steel%20blue%20palette%20with%20warm%20accents%2C%20tense%20mysterious%20cinematic%20mood%2C%20high%20contrast%20film%20still&width=1920&height=1080&seq=aa-hero-slide-3&orientation=landscape",
  },
  {
    id: "s-4",
    newsId: "n-2008",
    title: "2024年度影视盘点",
    kicker: "年度盘点",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20film%20scenes%20on%20dark%20navy%20background%2C%20warm%20orange%20spotlight%20and%20film%20reel%20elements%2C%20elegant%20editorial%20awards%20season%20mood%2C%20premium%20year-end%20review%20visual%2C%20highly%20detailed%20film%20still&width=1920&height=1080&seq=aa-hero-slide-4&orientation=landscape",
  },
];

export const quickCategories = [
  {
    type: "电视剧",
    label: "热门电视剧",
    desc: "古装 · 都市 · 悬疑追更不停",
    icon: "ri-tv-2-line",
  },
  {
    type: "电影",
    label: "精选电影",
    desc: "科幻 · 爱情 · 犯罪一网打尽",
    icon: "ri-film-line",
  },
  {
    type: "综艺",
    label: "热播综艺",
    desc: "真人秀 · 竞技 · 音乐见真我",
    icon: "ri-mic-line",
  },
];

export const siteStats = [
  { value: "12,800+", label: "收录影视作品" },
  { value: "3,600+", label: "每日资讯更新" },
  { value: "98%", label: "用户好评率" },
  { value: "15年", label: "影视内容深耕" },
];